/* eslint-disable no-unused-expressions */
import React from 'react';
import './ManagePostControlInfo.css';
import {Documents} from '../documents';
import {endsControlWithAfterControlNote, getPostControlDocuments} from '../documents/helpers';
import {store} from '../../Redux/Store/Store';
import * as actions from '../../Redux/Actions/Controls';
import * as actionsProg from '../../Redux/Actions/Programs';
import {connect} from 'react-redux';
import * as PropertyBucket from '../../Properties/Properties';
import * as ControlFunctions from '.././ManageControlCommons/ManageControlCommons';
import {Waiter} from '.././WaitingSign/Waiting';
import PopUp from '.././PopUp/PopUp';
import {UploadDocumentsPopup} from '../UploadDocumentsPopup/UploadDocumentsPopup';
import {RemarksPopup} from '../Remarks/RemarksDetail';
import SelectCustom from '../SelectCustom/SelectCustom';
import {getPostControlDocType} from '../../Helpers/utils';
import TableCustomLazyLoading from "../TableCustom/TableCustomLazyLoading";
import {cloneDeep} from "lodash";

class ManagePostControlInfo extends React.Component {

	columnsDefault = [
		{title: 'Numer kontroli', field: 'number', cellStyle: { width: '305px', minWidth: '305px' }},
		{title: 'Rodzaj dokumentu', field: 'documentType', width: 80},
		{title: 'Data rozpoczęcia kontroli', field: 'dateStart', width: 80, cellStyle: {textAlign: 'center'}},//term
		{title: 'Beneficjent', field: 'beneficiary', minWidth: 120, className: 'beneficiary'},
		{title: 'Rodzaj kontroli', field: 'controlKind', width: 110},//kind
		{title: 'Typ kontroli', field: 'controlType', width: 110},//type
		{title: 'Tryb kontroli', field: 'controlMode', width: 110},//mode
		{title: 'Zalecenia', field: 'followUpString', width: 90},//followUpString
		{title: 'Wdrożenie zaleceń', field: 'followUpStatus', width: 90},//followUpStatus
		{title: 'Data wysłania informacji ostatecznej', field: 'finalInfoSentDate', width: 90},//postControlInfoFinalIssueDate
		{title: 'Wynik kontroli', field: 'internalControlResult', width: 120}
	];
	previousInputFocusId = null;

	constructor(props) {
		super(props);
		this.state = {
			isWaiting: false,
			showPopup: false,
			isUploadDocsWindowVisible: false,
			showRemarksDetail: false,
			showDocumentsControl: null,
			tablePageSize: 10,
			page: this.props.match.params.pageNumber ? parseInt(this.props.match.params.pageNumber) - 1 : 0,
			programSearch: "",
			quickSearch: "",
			filter: [],
			orderBy: "number",
			orderById: "",
			orderDirection: "asc",
			filterChangeOnField: null,
			columns: cloneDeep(this.columnsDefault),
			documentTitle: 'e-Kontrole | Dokumenty pokontrolne'
		};
		this.postControlInfSelectIdSelectRef = React.createRef();
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
	}

	componentDidMount() {
		document.title = "e-Kontrole | Dokumenty pokontrolne";
		const {fetchControlData} = this.props;

		const newState = cloneDeep(this.state);
		if (this.props.controls.tableFilters.length && this.props.controls.tableName === document.title) {
			newState.columns = this.getDefaultFilters();
			newState.filter = this.props.controls.tableFilters;
		}
		if (this.props.controls.tableQuickSearch && this.props.controls.tableName === document.title) {
			newState.quickSearch = this.props.controls.tableQuickSearch;
		}
		if(this.props.match.params.pageNumber) {
			newState.page = parseInt(this.props.match.params.pageNumber) - 1;
		}
		if (store.getState().programs.selected) {
			newState.programSearch = [store.getState().programs.selected];
		}
		this.setState(newState);

		fetchControlData(newState.page, ControlFunctions.getFilterParam(newState.filter), [newState.orderBy, newState.orderDirection], newState.programSearch, newState.quickSearch, newState.tablePageSize, (e) => this.handleRedirect(e));
	}

	componentDidUpdate(prevState) {
		if (prevState.programs?.selected?.code !== this.props.programs?.selected?.code) {
			this.setValues([this.props.programs.selected]);
		}
	}

	handleRedirect = (e) => {
		if (e.totalPages <= this.state.page) {
			this.setState({
				page: 0
			});
			this.props.history.push(`/post_control`);
			const {fetchControlData} = this.props;
			fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize);
		}
	}

	getDefaultFilters = () => {
		const columns = cloneDeep(this.columnsDefault);

		this.props.controls.tableFilters.forEach((filter, index) => {
			if (filter.filterValue) {
				columns[index].defaultFilter = filter.filterValue
			}
		});

		return columns;
	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	setValues = (values) => {
		this.setState({programSearch: values})
		this.setState({page: parseInt(0) })
		this.props.history.push(`/post_control`);

		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], values, this.state.quickSearch, this.state.tablePageSize, true);

	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	showPopup = (title, notification, type, onClickEvent) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type, onClickEvent: onClickEvent}
		})

	};

	onDetailButtonClick = (row) => {
		this.props.history.push('/post_control/control_detail/' + row.id);
	};

	onListPreviewButtonClick = (row) => {
		this.props.history.push('/post_control/control_list_detail/' + row.id);
	};


	onPostInfoPreviewButtonClick = async (row) => {
		let documents = await getPostControlDocuments(row.id)
		let postControlInfo = documents[0].postControlInfo ? documents[0].postControlInfo.remarksIssueDate : null;
		if (row.postControlDocuments || postControlInfo !== null) {
			const { setFiltersData } = this.props;
			setFiltersData({ filter: this.state.filter, tableName: this.state.documentTitle });
			const { setQuickSearchData } = this.props;
			setQuickSearchData({quickSearch: this.state.quickSearch, tableName: this.state.documentTitle});
			this.showPopup('Dokumenty pokontrolne', ControlFunctions.displayInfosListTab(documents, row.number, row.id, 'post_control', () => {
				this.setState({
					record: row,
					documents: documents,
					isUploadDocsWindowVisible: true,
					showPopup: false,
					docType: getPostControlDocType(documents)
				});
			}), 'notify')
		} else {
			this.showPopup('Komunikat', 'Kontrola nie ma jeszcze dokumentu pokontrolnego.', 'notify')
		}
	};

	onFollowUpButtonClick = (row) => {
		if (row.followUp) {
			this.showPopup('Monitorowanie zaleceń', ControlFunctions.displayFollowUpInfo(row), 'notify')
		} else {
			this.showPopup('Komunikat', PropertyBucket.getNoFollowUpMessage(), 'notify')
		}
	};
	prepareData = (data) => {
		return data.map(ControlFunctions.setupControlData);
	};

	focusOnFilterElement(_this) {
		const field = _this.state.filter.find(x => {
			if (this.state.filterChangeOnField) {
				return x.field === this.state.filterChangeOnField.field;
			} else {
				return x.filterValue !== undefined;
			}
		});

		if (field) {
			const elements = document.getElementsByClassName('MuiInput-inputTypeSearch');
			let findInputToFocus = false;

			for (let i = 0; i < elements.length; i++) {
				if (elements[i].value.length && elements[i].value === field.filterValue) {
					elements[i].focus();
					findInputToFocus = true;
					this.previousInputFocusId = i;
				}
			}

			if (!findInputToFocus && field.filterValue === '' && this.previousInputFocusId != null) {
				elements[this.previousInputFocusId].focus();
				this.previousInputFocusId = null;
			}
		}
	}

	onRemarksButtonClick = async (row) => {
		if(row.objectionsReceivedDate)	{
			let documents = await getPostControlDocuments(row.id)
			this.setState({
				showRemarksDetail: true,
				record: row,
				documents: documents,
				showPopup: false
			});
		}
		else {
			this.showPopup('Komunikat', PropertyBucket.getNoPostControlRemarksMessage(), 'notify')
		}
	};

	handlePageChange(page, size) {
		this.setState({page: parseInt(page) })
		const {fetchControlData} = this.props;
		fetchControlData(page, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, size, true);
	}

	handleFilterChange(filter) {
		this.state.filter.forEach((filterField, id) => {
			if (filterField.filterValue !== filter[id].filterValue) {
				this.setState({ filterChangeOnField: filter[id] });
			}
		});

		this.setState({page: parseInt(0) })
		this.setState({filter: filter })
		this.props.history.push(`/post_control`);

		const {fetchControlData, setFiltersData} = this.props;
		setFiltersData({ filter, tableName: this.state.documentTitle });
		fetchControlData(0, ControlFunctions.getFilterParam(filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize, true, () => this.focusOnFilterElement(this));
	}

	handleQuickSearchChange(search) {
		this.setState({quickSearch: search, page: 0});
		this.props.history.push(`/post_control`);
		const {fetchControlData, setQuickSearchData} = this.props;
		const focusOnQuickSearchInput = () => {
			const element = document.querySelector('[placeholder="Szukaj"]');
			element.focus();
		};
		setQuickSearchData({quickSearch: this.state.quickSearch, tableName: this.state.documentTitle});
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, search, this.state.tablePageSize, true, focusOnQuickSearchInput);
	}

	handleOrderChange(column, order) {
		this.setState({page: parseInt(0) })
		const orderColumn = (this.state.columns[column] ? this.state.columns[column].field :'')
		this.setState({orderById: column})
		this.setState({orderBy: orderColumn})
		this.setState({orderDirection: order})
		this.props.history.push(`/post_control`);
		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [orderColumn, order], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize, true);
	}


	render() {
		const { roleDetails } = this.props.userData.user;
		let userRole = roleDetails.role;
		let loadedControlsData;
		loadedControlsData = this.state.loadedControlsData ? this.state.loadedControlsData : store.getState().controls.controls;
		let loadedProgsData;
		userRole === 'SA' ? loadedProgsData = store.getState().programs.programs : loadedProgsData = null;
		let table;
		let dropdown;
		let popUp;
		this.state.showPopup ?
			(popUp = <PopUp type={this.state.popUp.type}
			                title={this.state.popUp.title}
			                notification={this.state.popUp.notification}
			                link={this.state.popUp.link}
			                onClickEvent={this.state.popUp.onClickEvent}
			                closePopUp={this.handleClosePopUp}
			/>) : null;

		if (this.props.controls && this.props.controls.isLoading === false) {
			if (loadedControlsData.length >= 0) {
				let totalElements = 0
				if (loadedControlsData.length > 0) {
					totalElements = this.props.controls.filters.totalElements
				}

				this.prepareData(loadedControlsData);
				table = <TableCustomLazyLoading
					columns={this.state.columns}
					data={loadedControlsData}
					orderBy={this.state.orderById}
					orderDirection={this.state.orderDirection}
					count={totalElements}
					page={this.state.page}
					actions={[
						rowData => ({
							icon: 'library_books',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1', margin: 0, padding: 0 } },
							tooltip: <span>Szczegóły kontroli<span className='sr-only'> {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onDetailButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'find_in_page',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Podgląd listy<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onListPreviewButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'description',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Dokumenty pokontrolne<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onPostInfoPreviewButtonClick(rowData);
							},
						}),
						rowData => ({
							icon: 'message',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Zastrzeżenia<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onRemarksButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'library_add_check',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Monitorowanie zaleceń<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onFollowUpButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'folder',
							iconProps: {style: {fontSize: '24px', color: '#0d47a1'}},
							tooltip: <span>Pliki<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: async (event, rowData) => {
								let documents = await getPostControlDocuments(rowData.id)
								this.setState({endsControlWithAfterControlNote : endsControlWithAfterControlNote(documents)})
								this.setState({showDocumentsControl: rowData});
							},
						}),
					]}
					verticalAlign='baseline'
					initialPage={this.props.match.params.pageNumber ? parseInt(this.props.match.params.pageNumber) - 1 : 0}
					pageSize={this.state.tablePageSize}
					onChangePage={
						(page, size) => {
							this.props.history.push(`/post_control/${parseInt(page) + 1}`)
							this.setState({page: parseInt(page)})
							this.setState({tablePageSize: parseInt(size)})
							this.handlePageChange(parseInt(page), parseInt(size))
						}
					}
					onFilterChange={(value) => {
						this.handleFilterChange(value)
					}}
					onQuickSearchChange={(value) => {
						this.handleQuickSearchChange(value)
					}}
					quickSearch={this.state.quickSearch}
					onOrderChange={(column, order) => {
						this.handleOrderChange(column, order)}
					}
				/>;
			}
		}

		if (userRole === 'SA' && loadedProgsData.length > 0) {
			dropdown = <div id='progs_select'>
				<SelectCustom
					labelField='code'
					placeholder='Programy'
					valueField='code'
					options={loadedProgsData}
					onChange={(values) => this.setValues(values)}
					searchFn={(selectProps) => {
						if (selectProps.state.search !== this.state.previousSearch) {
							const checkOptionCode = selectProps.props?.options?.find(spec => spec.code.toUpperCase().includes(selectProps.state?.search.toUpperCase()));
							if (!checkOptionCode) {
								selectProps.state['search'] = this.state.previousSearch;
								this.setState({});
							} else {
								this.setState({
									previousSearch: selectProps.state.search
								})
							}
						}
					}}
					multi
					isMulti
					id='postControlInfSelectId'
					dropdownId='postControlInfDropdownId'
					label='Programy'
					parentRef={this.postControlInfSelectIdSelectRef}
				/>
			</div>
		}

		const { showDocumentsControl: control } = this.state;
		return (
			<div id='control_search'>
				{this.state.isUploadDocsWindowVisible && <UploadDocumentsPopup
																isPossibleSendData={false}
																isPossibleChangeDate={this.state.docType === 'INF' ? true : false}
																control={this.state.record}
																showPopup={this.showPopup}
																handleLoading={this.isWaitingOnOff}
																handleClose={() => this.setState({
																	isUploadDocsWindowVisible: false,
																})}
																/>}
				{this.state.showRemarksDetail &&<RemarksPopup
													data= {this.state.record}
													documents={this.state.documents}
													closeWindow = {() => this.setState({
														showRemarksDetail: false,
														})}
													onlyPreview = {true}
												/>}
				{popUp}
				<div>
					<h2 className='mb-5'>Dokumenty pokontrolne</h2>
					{userRole === 'SA' ? dropdown : null}
					<div id='controls_table'>
						{table}
					</div>
				</div>
				{control !== null &&
					<Documents
						controlUuid={control.uuid}
						endsWithAfterControlNote={this.state.endsControlWithAfterControlNote}
						hiddenButtons
						inPopup
						removingOnListForbidden
						withDocumentsList
						onCancel={() => this.setState({showDocumentsControl: null})}
					/>
				}
				<div id='waiter'><Waiter loading={this.state.isWaiting || this.props.controls.isLoading}/></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch, ownParams) => {
	let url = PropertyBucket.getPostControls();
	let page = 0;
	if(ownParams.match.params.pageNumber) {
		page = (ownParams.match.params.pageNumber-1)
	}
	return {
		fetchControlData: (pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, completedParam, successCallback) => dispatch(actions.getControlData(url, page, pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, completedParam, successCallback)),
		setFiltersData: (filters) => dispatch(actions.setFiltersData(filters)),
		setQuickSearchData: (quickSearch) => dispatch(actions.setQuickSearchData(quickSearch)),
	}
};
export const ManagePostControlInfoProvider = connect(mapStateToProps, mapDispatchToProps)(ManagePostControlInfo);
